// Keep the docker-entrypoint-env.sh default in sync with this ID.
export const DEFAULT_GOOGLE_ADS_ID = 'AW-18447665423';

export const GOOGLE_ADS_SCRIPT_ORIGIN = 'https://www.googletagmanager.com';
